<template>
  <div>
    <v-menu
        open-on-click
        :close-on-content-click="false"
        bottom
        offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            v-bind="attrs"
            v-on="on"
            text
            class="elevation-0 filter-button">
          <v-icon color="white">mdi-filter</v-icon>
          {{ btnText }}
        </v-btn>
      </template>
      <template #default>
        <div class="menu-lists">
          <!-- 状態フィルタ -->
          <v-list dense v-if="!hideStatusFilters">
            <header>状態</header>
            <v-list-item v-if="hasPreparingForPublic">
              <v-checkbox
                  v-model="showPreparingForPublic"
                  label="募集準備中を表示"
                  hide-details>
              </v-checkbox>
            </v-list-item>
            <v-list-item v-if="hasPublic">
              <v-checkbox
                  v-model="showPublic"
                  label="募集中を表示"
                  hide-details>
              </v-checkbox>
            </v-list-item>
            <v-list-item v-if="hasPreparingForSubscribe">
              <v-checkbox
                  v-model="showPreparingForSubscribe"
                  label="申込準備中を表示"
                  hide-details>
              </v-checkbox>
            </v-list-item>
            <v-list-item v-if="hasApplying">
              <v-checkbox
                  v-model="showApplying"
                  label="申込中を表示"
                  hide-details>
              </v-checkbox>
            </v-list-item>
            <v-list-item v-if="hasPreparingForRequest">
              <v-checkbox
                  v-model="showPreparingForRequest"
                  label="申請準備中を表示"
                  hide-details>
              </v-checkbox>
            </v-list-item>
            <v-list-item v-if="hasRequesting">
              <v-checkbox
                  v-model="showRequesting"
                  label="申請中を表示"
                  hide-details>
              </v-checkbox>
            </v-list-item>
            <v-list-item v-if="hasRevising">
              <v-checkbox
                  v-model="showRevising"
                  label="修正中を表示"
                  hide-details>
              </v-checkbox>
            </v-list-item>
            <v-list-item v-if="hasRejected">
              <v-checkbox
                  v-model="showRejected"
                  label="不成約を表示"
                  hide-details>
              </v-checkbox>
            </v-list-item>
            <v-list-item v-if="hasTrading">
              <v-checkbox
                  v-model="showTrading"
                  label="取引中を表示"
                  hide-details>
              </v-checkbox>
            </v-list-item>
            <v-list-item v-if="hasSuspended">
              <v-checkbox
                  v-model="showSuspended"
                  label="取引終了を表示"
                  hide-details>
              </v-checkbox>
            </v-list-item>
            <v-list-item v-if="hasPrivate">
              <v-checkbox
                  v-model="showPrivate"
                  label="募集停止を表示"
                  hide-details>
              </v-checkbox>
            </v-list-item>
          </v-list>

          <!-- 方向フィルタ -->
          <v-list v-if="!hideDirectionFilters">
            <header>方向</header>
            <v-list-item>
              <v-checkbox
                  v-model="showIssuer"
                  label="発行側を表示"
                  :disabled="!hasIssuer"
                  hide-details>
              </v-checkbox>
            </v-list-item>
            <v-list-item>
              <v-checkbox
                  v-model="showRecipient"
                  label="受領側を表示"
                  :disabled="!hasRecipient"
                  hide-details>
              </v-checkbox>
            </v-list-item>
          </v-list>

          <!-- 区分フィルタ -->
          <v-list v-if="!hideTypeFilters">
            <header>区分</header>
            <v-list-item>
              <v-checkbox
                  v-model="showProduce"
                  label="提供区分を表示"
                  :disabled="!hasProduce"
                  hide-details>
              </v-checkbox>
            </v-list-item>
            <v-list-item>
              <v-checkbox
                  v-model="showConsume"
                  label="利用区分を表示"
                  :disabled="!hasConsume"
                  hide-details>
              </v-checkbox>
            </v-list-item>
          </v-list>
        </div>
      </template>
    </v-menu>
  </div>
</template>

<script>

function buildMultiFilter(index, filterNames) {
  const selfName = filterNames[index];
  return {
    get() {
      return this.filters[selfName];
    },
    set(value) {
      this.filters[selfName] = value;
      this.emitFilters([selfName]);
    }
  };
}

function buildBinaryFilter(index, filterNames) {
  const selfName = filterNames[index];
  const oppositionName = filterNames[1 - index];
  return {
    get() {
      return this.filters[selfName];
    },
    set(value) {
      this.filters[selfName] = value;
      if(!this.filters[selfName] && !this.filters[oppositionName]) {
        this.filters[oppositionName] = true;
      }
      this.emitFilters([selfName]);
    }
  };
}

function buildHaving(fn, filterName) {
  return function() {
    if(this.statusFilters.length > 0 && filterName) {
      return this.statusFilters.includes(filterName);
    }

    if(this.tradeContracts) {
      return this.tradeContracts.some(fn);
    } else {
      return true;
    }
  };
}

const statusFilters = [
    'showPreparingForPublic', 'showPublic', 'showPreparingForSubscribe', 'showApplying',
    'showPreparingForRequest', 'showRequesting', 'showRevising', 'showRejected',
    'showTrading', 'showSuspended', 'showPrivate'
];

const directionFilters = [
  'showIssuer', 'showRecipient'
];

const typeFilters = [
  'showProduce', 'showConsume'
];

export default {
  name: "TradeContractFilter",
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    hideStatusFilters: {
      type: Boolean,
      default: false,
    },
    hideTypeFilters: {
      type: Boolean,
      default: false,
    },
    hideDirectionFilters: {
      type: Boolean,
      default: false,
    },
    statusFilters: {
      type: Array,
      default: () => []
    },
    tradeContracts: {
      type: Array,
      default: null
    },
    value: {
      type: Object,
    }
  },
  data() {
    return {
      filters: {
        // 状態
        showPreparingForPublic: true,
        showPublic: true,
        showPreparingForSubscribe: true,
        showApplying: true,
        showPreparingForRequest: true,
        showRequesting: true,
        showRevising: true,
        showRejected: true,
        showTrading: true,
        showSuspended: true,
        showPrivate: true,

        // 方向
        showIssuer: true,
        showRecipient: true,

        // 区分
        showProduce: true,
        showConsume: true,
      },
    };
  },
  created() {
    this.emitFilters([]);
  },
  computed: {
    btnText() {
      const showOnly = [];
      if(statusFilters.map(sf => this.filters[sf]).includes(false)) {
        showOnly.push("一部の状態")
      }
      if(this.filters.showIssuer && !this.filters.showRecipient) {
        showOnly.push("発行")
      } else if(!this.filters.showIssuer && this.filters.showRecipient) {
        showOnly.push("受領")
      }
      if(this.filters.showProduce && !this.filters.showConsume) {
        showOnly.push("提供区分")
      } else if(!this.filters.showProduce && this.filters.showConsume) {
        showOnly.push("利用区分")
      }
      if(showOnly.length) {
        return `${showOnly.join('・')}のみ表示`;
      } else {
        return '';
      }
    },
    // FILTER FLAGS ////////////////////////////////////////////////////////////////////////////////////////////////////

    // 状態
    showPreparingForPublic:    buildMultiFilter(0, statusFilters),
    showPublic:                buildMultiFilter(1, statusFilters),
    showPreparingForSubscribe: buildMultiFilter(2, statusFilters),
    showApplying:              buildMultiFilter(3, statusFilters),
    showPreparingForRequest:   buildMultiFilter(4, statusFilters),
    showRequesting:            buildMultiFilter(5, statusFilters),
    showRevising:              buildMultiFilter(6, statusFilters),
    showRejected:              buildMultiFilter(7, statusFilters),
    showTrading:               buildMultiFilter(8, statusFilters),
    showSuspended:             buildMultiFilter(9, statusFilters),
    showPrivate:               buildMultiFilter(10, statusFilters),

    // 方向
    showIssuer:                buildBinaryFilter(0, directionFilters),
    showRecipient:             buildBinaryFilter(1, directionFilters),

    // 区分
    showProduce:               buildBinaryFilter(0, typeFilters),
    showConsume:               buildBinaryFilter(1, typeFilters),

    // FILTER AVAILABILITIES ///////////////////////////////////////////////////////////////////////////////////////////

    // 状態
    hasPreparingForPublic:     buildHaving(tc => tc.status === 'preparing' && tc.isPublishMode, 'showPreparingForPublic'),
    hasPublic:                 buildHaving(tc => tc.status === 'public', 'showPublic'),
    hasPreparingForSubscribe:  buildHaving(tc => tc.status === 'preparing' && tc.isSubscribeMode, 'showPreparingForSubscribe'),
    hasApplying:               buildHaving(tc => tc.status === 'applying', 'showApplying'),
    hasPreparingForRequest:    buildHaving(tc => tc.status === 'preparing' && tc.isRequestMode, 'showPreparingForRequest'),
    hasRequesting:             buildHaving(tc => tc.status === 'requesting', 'showRequesting'),
    hasRevising:               buildHaving(tc => tc.status === 'revising', 'showRevising'),
    hasRejected:               buildHaving(tc => tc.status === 'rejected', 'showRejected'),
    hasTrading:                buildHaving(tc => tc.status === 'trading', 'showTrading'),
    hasSuspended:              buildHaving(tc => tc.status === 'suspended', 'showSuspended'),
    hasPrivate:                buildHaving(tc => tc.status === 'private', 'showPrivate'),

    // 方向
    hasIssuer:                 buildHaving(tc => tc.amiIssuer),
    hasRecipient:              buildHaving(tc => tc.amiRecipient),

    // 区分
    hasProduce:                buildHaving(tc => tc.isSelfProduce),
    hasConsume:                buildHaving(tc => tc.isSelfConsume),
  },
  methods: {
    emitFilters(changeFilters) {
      const f = {...this.filters};
      this.$emit('change', f, changeFilters);
      this.$emit('apply-filter', tc =>
        ((f.showIssuer && tc.amiIssuer) || (f.showRecipient && tc.amiRecipient)) &&
        ((f.showProduce && tc.isSelfProduce) || (f.showConsume && tc.isSelfConsume)) &&
        (
            (f.showPreparingForPublic && tc.status === 'preparing' && tc.isPublishMode) ||
            (f.showPublic && tc.status === 'public') ||
            (f.showPreparingForSubscribe && tc.status === 'preparing' && tc.isSubscribeMode) ||
            (f.showApplying && tc.status === 'applying') ||
            (f.showPreparingForRequest && tc.status === 'preparing' && tc.isRequestMode) ||
            (f.showRequesting && tc.status === 'requesting') ||
            (f.showRevising && tc.status === 'revising') ||
            (f.showRejected && tc.status === 'rejected') ||
            (f.showTrading && tc.status === 'trading') ||
            (f.showSuspended && tc.status === 'suspended') ||
            (f.showPrivate && tc.status === 'private')
        )
      );
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.filters = {
          ...this.$options.data.apply(this).filters,
          ...value
        };
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-lists {
  display: flex;
  flex-direction: row;
  align-items: stretch;

  & > .v-list:not(:last-child) {
    border-right: 1px solid #DDD;
  }

  & > .v-list > header {
    color: rgba(0, 0, 0, 0.67);
    font-size: 90%;
    margin: 0.3rem 0;
  }
}

.v-input--selection-controls,
.v-divider {
  padding-top: 0;
  margin-top: 5px;
  margin-bottom: 5px;
}

.v-btn.filter-button {
  padding: 0 8px;
  min-width: fit-content;
}
</style>
